import { LanguageSelectionHelper } from "app/helpers/languageSelectionHelper";
import { SetupTranslations } from "app/localization/translations";
import type { EventType } from "app/types/eventType";
import { LiveGolfStatus } from "app/utils/const";
import IntlProvider from "react-intl/src/components/provider";
import "../../../../src/app/components/GolfPhase/GolfPhase.scss";
const language = LanguageSelectionHelper.checkSelectedLanguage();
const messages = SetupTranslations(language);

const translatePlayersStatus = status => {
  return messages[status] || status;
};

const getHumanReadablePhase = (eventPhase, messages) => {
  if (!eventPhase) {
    return messages["golf-live-no-data-available"];
  }
  const phaseParts = eventPhase.split("_");
  if (phaseParts.length < 2) {
    return eventPhase;
  }
  const roundNumber = phaseParts[1];
  const remainingPhase = phaseParts.slice(2).join("_");

  // Handle the specific cases "started" and "finished"
  if (remainingPhase === LiveGolfStatus["STARTED"]) {
    return `${messages["golf-live-round"]} ${roundNumber} - ${messages["golf-live-started"]}`;
  } else if (remainingPhase === LiveGolfStatus["FINISHED"]) {
    return `${messages["golf-live-round"]} ${roundNumber} - ${messages["golf-live-finished"]}`;
  }
  return `${messages["golf-live-round"]} ${roundNumber} - ${remainingPhase}`;
};

const getPlayerCourseStatus = eventIncidents => {
  if (!eventIncidents || eventIncidents.length === 0) {
    return {
      status: translatePlayersStatus("no-data-available"),
      className: "playerCourseStatusEmpty",
    };
  }
  const playersOnCourse = eventIncidents[0].type;
  const translatedStatus = messages[playersOnCourse] || playersOnCourse;
  const statusText = translatePlayersStatus(translatedStatus);
  const statusClassName =
    playersOnCourse === "PLAYERS_ON_COURSE"
      ? "players-on-course"
      : "players-off-course";
  return { status: statusText, className: statusClassName };
};

export const GolfPhase = (props: { eventData: EventType }) => {
  const { eventData } = props;
  const eventPhase = eventData?.eventPhase;
  const humanReadablePhase = getHumanReadablePhase(eventPhase, messages);
  const playerCourseStatus = getPlayerCourseStatus(eventData?.eventIncidents);
  return (
    <IntlProvider locale={language} messages={messages}>
      <div className="event__golf-phase-section">
        <div className="golf-phase-text">{humanReadablePhase}</div>
        {playerCourseStatus.status !== "UNKNOWN" && (
          <div
            className={`players-course-status ${playerCourseStatus.className}`}
          >
            {playerCourseStatus.status}
          </div>
        )}
      </div>
    </IntlProvider>
  );
};
